import { render } from "./SideSelection.vue?vue&type=template&id=88360c9c"
import script from "./SideSelection.vue?vue&type=script&lang=js"
export * from "./SideSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__